import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import DesktopLayout from './DesktopLayout'
import MobileLayout from './MobileLayout'

/**
 * Layout orchestrator — switches between desktop (md+) and mobile layouts.
 * noSsr avoids a flash-of-wrong-layout on first render in SPA mode.
 */
const Layout = () => {
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })
    return isDesktop ? <DesktopLayout /> : <MobileLayout />
}

export default Layout
